export interface GroupFormState {
  loading: boolean;
}

export namespace GroupFormState {
  export const initialState: GroupFormState = {
    loading: false,
  };
}
